import { AxiosRequestConfig } from 'axios';
import client from '../client';

export function get(id?: number, customConfig?: AxiosRequestConfig) {
    const url = `/chat/${id}`;
    return client.get(url, customConfig);
}
